import { useMemo } from 'react';
import { Flex, Select } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { convertQueryObjToString, mapQueryStringToFilterObject } from '@components-web/filters/helper';
import { strings } from '@constants/strings';
import { FaChevronDown } from 'react-icons/fa6';

const SortDropdown = ({ sortOptions = [] }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryObj = useMemo(() => {
    return mapQueryStringToFilterObject(location.search).queryObj || {};
  }, [location.search]);

  const updateSortInQueryParams = (key, order) => {
    let updatedQuery = { ...queryObj };

    Object.keys(updatedQuery).forEach((key) => {
      if (key?.startsWith('sort[')) {
        delete updatedQuery[key];
      }
    });

    if (key && order) {
      updatedQuery[`sort[${key}]`] = order;
    }

    navigate({
      pathname: location.pathname,
      search: `?${convertQueryObjToString(updatedQuery)}`,
    });
  };

  if (sortOptions.length === 0) {
    return null;
  }

  const getCurrentSortLabel = () => {
    const sortKeys = Object.keys(queryObj).filter((key) => key?.startsWith('sort['));
    if (!sortKeys?.length) return 'Default';

    const sortKey = sortKeys[0];
    const key = sortKey?.replace('sort[', '').replace(']', '');
    const order = queryObj[sortKey];

    const matchingOption = sortOptions.find((option) => option?.key === key && option?.order === order);

    return matchingOption ? matchingOption?.label : 'Default';
  };

  const handleSortChange = (selectedLabel) => {
    const selectedOption = sortOptions?.find((option) => option?.label === selectedLabel);
    if (selectedOption) {
      updateSortInQueryParams(selectedOption?.key, selectedOption?.order);
    }
  };

  return (
    <Flex justify="flex-end" align="center" style={{ marginBottom: -10 }}>
      <span style={{ marginRight: 8, fontWeight: 600 }}>{strings.sort_by}</span>
      <Select
        value={getCurrentSortLabel()}
        onChange={handleSortChange}
        options={sortOptions.map((option) => ({
          value: option.label,
          label: option.label,
        }))}
        style={{ minWidth: 200 }}
        suffixIcon={<FaChevronDown color="var(--gray-500)" />}
      />
    </Flex>
  );
};

export default SortDropdown;
